import React from "react";
import "./ar-title.css";

const ArTitle = (props) => {
  return <span className="ar-name">{props.title}</span>;
};

export default ArTitle;